import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchServices,
  createService,
  updateService,
  deleteService,
} from '../../features/Services/serviceSlice';
import { Button, Table, Modal, Form, Input, Space, Popconfirm, message } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

const Services = () => {
  const dispatch = useDispatch();
  const { services = [], loading } = useSelector((state) => state.services);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingService, setEditingService] = useState(null);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  const handleAdd = () => {
    setEditingService(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const filteredServices = services.filter((serv) =>
    serv.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleEdit = (service) => {
    setEditingService(service);
    form.setFieldsValue(service);
    setIsModalVisible(true);
  };

  const handleDelete = (id) => {
    dispatch(deleteService(id))
      .unwrap()
      .then(() => message.success('Service deleted successfully'))
      .catch(() => message.error('Failed to delete Service'));
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (editingService) {
        await dispatch(updateService({ id: editingService.id, ...values })).unwrap();
        message.success('Service updated successfully');
      } else {
        await dispatch(createService(values)).unwrap();
        message.success('Service created successfully');
      }
      setIsModalVisible(false);
    } catch (error) {
      message.error(error.message || 'An error occurred');
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this service?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button type="link" icon={<DeleteOutlined />} danger>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="users-page">
      <h3 className='user-title'>Services Management</h3>
      <Button className='add-button'
        type="primary"
        style={{ marginBottom: 16 }}
        onClick={handleAdd}>
        Add Service
      </Button>
      <Input.Search
        placeholder="Search services"
        value={searchText}
        onChange={(e) => handleSearch(e.target.value)}
        style={{ marginBottom: 16 }}
      />
      <Table
        dataSource={filteredServices}
        columns={columns}
        loading={loading}
        rowKey="id"
        scroll={{ x: true }}
        pagination={{ pageSize: 10 }}
      />

      <Modal
        title={editingService ? 'Edit Service' : 'Add Service'}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handleSubmit}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Services;